import { Component } from '@angular/core';

import { ActivitiesBaseComponent } from '../../activities.base.service';

@Component({
  selector: 'app-activities-uploaded',
  templateUrl: './activities-uploaded.component.html',
  styleUrls: ['./activities-uploaded.component.scss'],
})
export class ActivitiesUploadedComponent extends ActivitiesBaseComponent {}
